import React, {useEffect, useMemo, useState} from 'react'
import {dataAniversarioFields, mapDataAniversarioToTable} from "./data-aniversario-fields"
import {Paper} from "@mui/material"
import DynamicColumnTable from "../../../componentes/dynamic-column-table"
import PropTypes from "prop-types"
import {copyTable, pasteTableFromClipboard} from "../../../../utils/csv-utils"
import MotorDataAniversarioService from "../../../../../../../services/motor-data-aniversario-service"
import {useLocation} from "react-router-dom"

const DataAniversarioTable = ({
    setLoading,
    idCaracteristica,
    eventoPublicado,
    showDataAniversario,
    datasProjetadas,
    tableData,
    setTableData,
    clearTable
}) => {

    const service = useMemo(() => new MotorDataAniversarioService(), [])
    const [tableKey, setTableKey] = useState(Math.random() * 10)
    const location = useLocation()
    const navigationState = location.state

    useEffect(() => {
        if (!showDataAniversario) return
        if (!idCaracteristica) return

        if (Array.isArray(datasProjetadas) && datasProjetadas.length > 0) {
            const formatted = mapDataAniversarioToTable(datasProjetadas)
            setTableData(formatted)
        } else {
            loadDataAniversario()
        }
    }, [showDataAniversario, idCaracteristica])

    useEffect(() => {
        const {origem} = navigationState
        if (origem === "duplicar") {
            const {data} = navigationState
            const {dataAniversario} = data
            setTableData(mapDataAniversarioToTable(dataAniversario))
        }
    }, [])

    const loadDataAniversario = () => {
        setLoading(true)

        service.getDataAniversario(idCaracteristica)
            .then(response => {
                const {body} = response

                if (body && body.length > 0) {
                    eventoPublicado(true)
                    const formatted = mapDataAniversarioToTable(body)
                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    loadDataAniversarioTemporario()
                }
            })
            .catch(error => console.error("Erro getDataAniversario:", error))
            .finally(() => setLoading(false))
    }

    const loadDataAniversarioTemporario = () => {
        setLoading(true)

        service.getTemporarioDataAniversario(idCaracteristica)
            .then(response => {
                const bodyTemp = response?.body || response?.data

                if (bodyTemp) {
                    eventoPublicado(false)

                    // Extrair array de DatasAniversario do objeto temporário
                    const aniversarios = Array.isArray(bodyTemp)
                        ? bodyTemp
                        : bodyTemp?.DatasAniversario || []


                    const formatted = mapDataAniversarioToTable(aniversarios)

                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    console.warn("Nenhum dado temporário encontrado")
                }
            })
            .catch(error => console.error("Erro getTemporarioDataAniversario:", error))
            .finally(() => setLoading(false))
    }

    return (
        <Paper sx={{mt: 2}}>
            <DynamicColumnTable
                key={tableKey}
                actionButtons={true}
                copyData={() => copyTable(tableData, dataAniversarioFields)}
                pasteData={async () => await pasteTableFromClipboard(dataAniversarioFields, setTableData)}
                clearTable={() => clearTable(setTableData)}
                fields={dataAniversarioFields}
                items={tableData}
                setItems={setTableData}
            />
        </Paper>
    )
}

DataAniversarioTable.propTypes = {
    setLoading: PropTypes.bool,
    idCaracteristica: PropTypes.number,
    eventoPublicado: PropTypes.func,
    showDataAniversario: PropTypes.bool,
    datasProjetadas: PropTypes.array,
    tableData: PropTypes.array,
    setTableData: PropTypes.func,
    clearTable: PropTypes.func,
}

export default DataAniversarioTable